<!-- appendTo: o painel dos ng-select abre na janela do modal (position: fixed) para nao ser cortado
     pelo scroll do simplebar; em ecras baixos abria para cima e as primeiras opcoes ficavam inacessiveis.
     appCloseSelectsOnScroll fecha o painel quando o separador faz scroll, porque ja nao acompanha o campo. -->
<ngx-simplebar appCloseSelectsOnScroll class="px-3 mx-n3 mb-2" style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));"
  [options]="{ forceVisible: true }">
  <form [formGroup]="propertyAddressForm" *ngIf="isView$.getValue()" #formElementRef>
    <!-- Em ecrãs largos: formulário à esquerda e mapa fixo à direita, numa largura
         máxima centrada, para os campos não ficarem desproporcionados no modal fullscreen. -->
    <div class="address-layout">
      <div class="row">
        <div class="col-xl-7">
          <!-- Localização: divisão administrativa -->
          <div class="card address-card border shadow-none">
            <div class="card-header d-flex align-items-start py-3">
              <div class="flex-grow-1">
                <h5 class="card-title mb-1">{{ 't-m-properties.t-location' | translate }}</h5>
                <p class="text-muted fs-12 mb-0">{{ 't-m-properties.t-location-help' | translate }}</p>
              </div>

              <!-- o que fica escondido nos portais/site -->
              <div class="dropdown flex-shrink-0 ms-2">
                <button class="btn btn-outline-primary waves-effect waves-primary btn-sm dropdown border-input-custom"
                  type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside"><i
                    class=" ri-settings-2-line fs-14"></i>
                </button>
                <div class="border border-primary dropdown-menu dropdown-menu-end p-3 border-input-custom"
                  style="min-width: 12rem;">
                  <div class="d-flex flex-column gap-2 filter-check">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="hide-address"
                        formControlName="hidePropertyAddress">
                      <label class="form-check-label" for="hide-address">
                        {{ 't-m-properties.t-hide-address' | translate }}
                      </label>
                    </div>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="hide-georeference"
                        formControlName="hideMap">
                      <label class="form-check-label" for="hide-georeference">
                        {{ 't-m-properties.t-hide-georeference' | translate }}
                      </label>
                    </div>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="hide-district"
                        formControlName="hideDistrict">
                      <label class="form-check-label" for="hide-district">
                        {{ 't-m-properties.t-hide-district' | translate }}
                      </label>
                    </div>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="hide-county"
                        formControlName="hideCounty">
                      <label class="form-check-label" for="hide-county">
                        {{ 't-m-properties.t-hide-county' | translate }}
                      </label>
                    </div>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="hide-parish"
                        formControlName="hideParish">
                      <label class="form-check-label" for="hide-parish">
                        {{ 't-m-properties.t-hide-parish' | translate }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="countryInput" class="form-label">
                      {{ 't-m-properties.t-country' | translate }}
                    </label>
                    <ng-select appendTo=".modal-create-properties" [items]="countries" [multiple]="false"
                      placeholder="{{ 't-general.t-select' | translate }} {{ 't-m-properties.t-country' | translate }}"
                      bindLabel="name" bindValue="id" required formControlName="country"
                      [ngClass]="{
                        'is-invalid': submitted && form['country'].errors && form['country'].errors['required'],
                        'is-warning': submitted && form['country'].errors && form['country'].errors['warning'] }"
                      (change)="changeCountry($event)" [clearable]="false">
                    </ng-select>
                    <div *ngIf="submitted && form['country'].errors" class="invalid-feedback" align="left">
                      <div *ngIf="form['country'].errors['required']">
                        {{ 't-m-properties.t-country' | translate }}
                        {{ 't-general.t-is-required'|translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <!--end col-->

                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="regionInput" class="form-label">
                      {{ 't-m-properties.t-region' | translate }}
                    </label>
                    <ng-select appendTo=".modal-create-properties" [items]="regions" [multiple]="false"
                      placeholder="{{ 't-general.t-select' | translate }}  {{ 't-m-properties.t-region' | translate }}"
                      bindLabel="name" bindValue="id" required formControlName="region"
                      [ngClass]="{
                        'is-invalid': submitted && form['region'].errors && form['region'].errors['required'],
                        'is-warning': submitted && form['region'].errors && form['region'].errors['warning'] }"
                      (change)="changeRegion($event)" [clearable]="false">
                    </ng-select>
                    <div *ngIf="submitted && form['region'].errors" class="invalid-feedback" align="left">
                      <div *ngIf="form['region'].errors['required']">
                        {{ 't-m-properties.t-region' | translate }}
                        {{ 't-general.t-is-required'|translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <!--end col-->

                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="districtInput" class="form-label">
                      {{ 't-m-properties.t-district' | translate }}
                    </label>
                    <ng-select appendTo=".modal-create-properties" [items]="districts" [multiple]="false"
                      placeholder="{{ 't-general.t-select' | translate }} {{ 't-m-properties.t-district' | translate }}"
                      bindLabel="name" bindValue="id" required formControlName="district"
                      [ngClass]="{
                        'is-invalid': submitted && form['district'].errors && form['district'].errors['required'],
                        'is-warning': submitted && form['district'].errors && form['district'].errors['warning'] }"
                      (change)="changeDistrict($event)" [clearable]="false">
                    </ng-select>
                    <div *ngIf="submitted && form['district'].errors" class="invalid-feedback" align="left">
                      <div *ngIf="form['district'].errors['required']">
                        {{ 't-m-properties.t-district' | translate }}
                        {{ 't-general.t-is-required'|translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <!--end col-->

                <div class="col-lg-6">
                  <div class="mb-3 mb-lg-0">
                    <label for="countyInput" class="form-label">
                      {{ 't-m-properties.t-county' | translate }}
                    </label>
                    <ng-select appendTo=".modal-create-properties" [items]="counties" [multiple]="false"
                      placeholder="{{ 't-general.t-select' | translate }}  {{ 't-m-properties.t-county' | translate }}"
                      bindLabel="name" bindValue="id" required formControlName="county"
                      [ngClass]="{
                        'is-invalid': submitted && form['county'].errors && form['county'].errors['required'],
                        'is-warning': submitted && form['county'].errors && form['county'].errors['warning'] }"
                      (change)="changeCounty($event)" [clearable]="false">
                    </ng-select>
                    <div *ngIf="submitted && form['county'].errors" class="invalid-feedback" align="left">
                      <div *ngIf="form['county'].errors['required']">
                        {{ 't-m-properties.t-county' | translate }}
                        {{ 't-general.t-is-required'|translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <!--end col-->

                <div class="col-lg-6">
                  <div class="mb-0">
                    <label for="parishInput" class="form-label">
                      {{ 't-m-properties.t-parish' | translate }}
                    </label>
                    <ng-select appendTo=".modal-create-properties" class="parish-select" [items]="parishes" [multiple]="false"
                      (change)="autoRefreshGeoreference()"
                      placeholder="{{ 't-general.t-select' | translate }}  {{ 't-m-properties.t-parish' | translate }}"
                      bindLabel="name" bindValue="id" required formControlName="parish"
                      [ngClass]="{
                        'is-invalid': submitted && form['parish'].errors && form['parish'].errors['required'],
                        'is-warning': submitted && form['parish'].errors && form['parish'].errors['warning'] }"
                      [clearable]="false">
                    </ng-select>
                    <div *ngIf="submitted && form['parish'].errors" class="invalid-feedback" align="left">
                      <div *ngIf="form['parish'].errors['required']">
                        {{ 't-m-properties.t-parish' | translate }}
                        {{ 't-general.t-is-required'|translate }}
                      </div>
                    </div>
                    <div *ngIf="showOutdatedParishNotice" class="form-text text-muted" align="left">
                      <i class="ri-error-warning-line align-bottom"></i>
                      {{ 't-m-properties.t-outdated-parish' | translate }}
                    </div>
                  </div>
                </div>
                <!--end col-->
              </div>
              <!--end row-->
            </div>
          </div>
          <!-- end card -->

          <!-- Morada: dados do contrato e dos portais -->
          <div class="card address-card border shadow-none">
            <div class="card-header py-3">
              <h5 class="card-title mb-1">{{ 't-m-properties.t-address-section' | translate }}</h5>
              <p class="text-muted fs-12 mb-0">{{ 't-m-properties.t-address-section-help' | translate }}</p>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="addressInput" class="form-label">
                      {{ 't-m-properties.t-address' | translate }}
                    </label>
                    <input type="text" class="form-control" id="addressInput" (change)="autoRefreshGeoreference()"
                      placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-address' | translate | lowercase }}"
                      formControlName="address"
                      [ngClass]="{ 'is-warning': submitted && form['address'].errors && form['address'].errors['warning'] }" />
                  </div>
                </div>
                <!--end col-->

                <div class="col-lg-3">
                  <div class="mb-3">
                    <label for="zipcodeInput" class="form-label">
                      {{ 't-m-properties.t-zip-code' | translate }}
                    </label>
                    <input type="text" class="form-control" id="zipcodeInput" [placeholder]="postalCodeFormat"
                      [mask]="postalCodeFormat" formControlName="zipCode" (change)="autoRefreshGeoreference()"
                      [ngClass]="{ 'is-warning': submitted && form['zipCode'].errors && form['zipCode'].errors['warning'] }" />
                  </div>
                </div>
                <!--end col-->

                <!-- zona: texto livre, mostrado na listagem e no preview -->
                <div class="col-lg-3">
                  <div class="mb-3">
                    <label for="zoneInput" class="form-label d-flex align-items-center gap-1">
                      {{ 't-m-properties.t-zone' | translate }}
                      <span class="text-muted fw-normal">({{ 't-optional' | translate | lowercase }})</span>
                      <i class="ri-question-line text-primary fs-20 lh-1 c-pointer" tabindex="0"
                        [ngbTooltip]="'t-m-properties.t-zone-help' | translate" tooltipClass="zone-tooltip" placement="top"
                        container="body" triggers="hover focus"></i>
                    </label>
                    <input type="text" class="form-control" id="zoneInput" maxlength="255"
                      placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-zone' | translate | lowercase }}"
                      formControlName="zone" />
                  </div>
                </div>
                <!--end col-->
              </div>
              <!--end row-->

              <div class="row">
                <div class="col-6 col-lg-2">
                  <div class="mb-3 mb-lg-0">
                    <label for="doorInput" class="form-label">
                      {{ 't-m-properties.t-door' | translate }}
                    </label>
                    <input type="text" class="form-control" id="doorInput"
                      placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-door' | translate | lowercase }}"
                      formControlName="doorNumber" />
                  </div>
                </div>
                <!--end col-->

                <div class="col-6 col-lg-2">
                  <div class="mb-3 mb-lg-0">
                    <label for="fractionInput" class="form-label">
                      {{ 't-m-properties.t-fraction' | translate }}
                      <span class="text-muted fw-normal">({{ 't-optional' | translate | lowercase }})</span>
                    </label>
                    <input type="text" class="form-control" id="fractionInput"
                      placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-fraction' | translate | lowercase }}"
                      formControlName="fraction" />
                  </div>
                </div>
                <!--end col-->

                <div class="col-6 col-lg-2">
                  <div class="mb-0">
                    <label for="floorInput" class="form-label">
                      {{ 't-m-properties.t-floor' | translate }}
                    </label>
                    <input type="text" class="form-control" id="floorInput"
                      placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-floor' | translate | lowercase }}"
                      formControlName="floor">
                  </div>
                </div>
                <!--end col-->
              </div>
              <!--end row-->
            </div>
          </div>
          <!-- end card -->
        </div>

        <div class="col-xl-5">
          <div class="address-side">
            <!-- Geo referência -->
            <div class="card address-card border shadow-none">
              <div class="card-header d-flex align-items-start flex-wrap gap-2 py-3">
                <div class="flex-grow-1">
                  <h5 class="card-title mb-1">{{ 't-m-properties.t-geo-reference' | translate }}</h5>
                  <p class="text-muted fs-12 mb-0">{{ 't-m-properties.t-geo-reference-help' | translate }}</p>
                </div>

                <div class="d-flex align-items-center gap-2 flex-shrink-0">
                  <!-- voltar a procurar a posição pela morada -->
                  <button *ngIf="!validateLocationBtn()" type="button" class="btn btn-light btn-sm btn-icon border"
                    ngbTooltip="{{form['country'].value && form['country'].value !== portugalCountry?.id ? ('t-georeference-tooltip-nozip' | translate) : ('t-georeference-tooltip' | translate)}}"
                    container="body"><i class="fs-16 mdi mdi-refresh"></i></button>
                  <button *ngIf="validateLocationBtn()" type="button" class="btn btn-light btn-sm btn-icon border"
                    (click)="refreshGeoreference()"><i class="fs-16 mdi mdi-refresh"></i></button>

                  <button type="button" class="btn btn-light btn-sm border d-flex align-items-center gap-1"
                    [class.active]="showManualCoordinates" (click)="toggleManualCoordinates()">
                    <i class="ri-map-pin-line"></i>
                    {{ 't-m-properties.t-manual-coordinates' | translate }}
                    <i [ngClass]="showManualCoordinates ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
                  </button>
                </div>
              </div><!-- end card header -->

              <div class="card-body">
                <div class="address-map position-relative">
                  <div class="map-container" leaflet [leafletOptions]="options" (leafletMapReady)="onMapReady($event)"
                    (leafletDoubleClick)="mapDblClick($event)">
                  </div>

                  <!-- ações sobre o mapa -->
                  <div class="address-map-actions d-flex gap-1">
                    <button type="button" class="btn btn-light btn-sm shadow-sm d-flex align-items-center gap-1"
                      (click)="toggleSatellite()">
                      <i class="ri-earth-line"></i>
                      {{ (isSatellite ? 't-m-properties.t-map-view' : 't-m-properties.t-satellite') | translate }}
                    </button>
                    <button type="button" class="btn btn-light btn-sm btn-icon shadow-sm" (click)="centerOnMarker()"
                      [ngbTooltip]="'t-m-properties.t-center-marker' | translate" placement="top" container="body">
                      <i class="ri-focus-3-line"></i>
                    </button>
                  </div>
                </div>

                <!-- coordenadas: só editáveis em "Coordenadas manuais" -->
                <div class="row g-3 mt-2 flex-shrink-0">
                  <div class="col-md-6">
                    <label class="form-label" for="latitude">{{ 't-latitude' | translate }}</label>
                    <input id="latitude" class="form-control" type="number" step="any" formControlName="latitude"
                      [readonly]="!showManualCoordinates" (focus)="showManualCoordinates && onManualCoordinateFocus()"
                      (input)="onManualCoordinateChange()" (blur)="onManualCoordinateBlur()" placeholder="38.7223" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-label" for="longitude">{{ 't-longitude' | translate }}</label>
                    <input id="longitude" class="form-control" type="number" step="any" formControlName="longitude"
                      [readonly]="!showManualCoordinates" (focus)="showManualCoordinates && onManualCoordinateFocus()"
                      (input)="onManualCoordinateChange()" (blur)="onManualCoordinateBlur()" placeholder="-9.1393" />
                  </div>

                  <div class="col-12" *ngIf="showManualCoordinates">
                    <div class="text-danger fs-12" *ngIf="manualCoordsInvalid">
                      {{ 't-m-properties.t-manual-coordinates-invalid' | translate }}
                    </div>
                    <div class="form-text text-muted" *ngIf="!manualCoordsInvalid">
                      {{ 't-m-properties.t-manual-coordinates-hint' | translate }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- end card-body -->
            </div><!-- end card -->
          </div>
        </div>
      </div>
    </div>
  </form>
</ngx-simplebar>
